/*
  Arranque del vídeo de portada.

  El marcado ya sale con autoplay, muted, loop y playsinline, que es la receta
  correcta y basta en la mayoría de los casos. Pero no siempre: iOS en modo de
  bajo consumo, el ahorro de datos de Android y el bloqueo manual por sitio en
  Chrome tumban el autoplay aunque el vídeo esté silenciado. Cuando eso pasa se
  queda el póster quieto y parece que la landing está rota.

  Aquí no se adivina si el navegador va a dejar: se intenta, y si dice que no,
  se le da al visitante un botón para arrancarlo. Un vídeo parado con un botón
  encima se entiende; un vídeo parado sin nada, no.

  Un toque en cualquier sitio de la página también libera la reproducción: en
  iOS el primer gesto del usuario desbloquea el medio, así que se reintenta.
*/
(function () {
  'use strict';

  var VIDEO = 'video[autoplay]';
  var BOTON = '[data-lander-play]';

  function contenedor(video) {
    return video.closest('.lander-hero__media') || video.parentNode;
  }

  function mostrarBoton(video) {
    var caja = contenedor(video);
    if (!caja) return;
    var boton = caja.querySelector(BOTON);
    if (boton) boton.hidden = false;
  }

  function ocultarBoton(video) {
    var caja = contenedor(video);
    if (!caja) return;
    var boton = caja.querySelector(BOTON);
    if (boton) boton.hidden = true;
  }

  function intentar(video) {
    // play() devuelve una promesa en todos los navegadores que nos importan,
    // pero en los viejos devuelve undefined. Sin la comprobación, .catch peta.
    var promesa = video.play();
    if (!promesa || typeof promesa.catch !== 'function') return;
    promesa.then(function () {
      ocultarBoton(video);
    }).catch(function () {
      mostrarBoton(video);
    });
  }

  function arrancarTodos() {
    document.querySelectorAll(VIDEO).forEach(intentar);
  }

  function alPulsar(evento) {
    var boton = evento.target.closest(BOTON);
    if (!boton) return;
    var caja = boton.closest('.lander-hero__media');
    var video = caja && caja.querySelector('video');
    if (video) intentar(video);
  }

  document.addEventListener('click', alPulsar);

  // Quien pide menos movimiento no recibe un vídeo arrancando solo. Se queda el
  // póster y el botón, que es lo que esa preferencia significa.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll(VIDEO).forEach(function (video) {
        video.removeAttribute('autoplay');
        video.pause();
        mostrarBoton(video);
      });
    });
    return;
  }

  document.addEventListener('DOMContentLoaded', arrancarTodos);

  // El primer gesto del visitante desbloquea el medio en iOS. Se reintenta una
  // sola vez: si a la segunda tampoco arranca, el botón ya está puesto.
  document.addEventListener('pointerdown', function reintento() {
    document.removeEventListener('pointerdown', reintento);
    arrancarTodos();
  });
})();
